module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-filter-component"
  }, [(!_vm.formOpened) ? _c('div', [_c('div', {
    staticClass: "select-component"
  }, [_c('multiselect', {
    staticClass: "select-component",
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.availableValues,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name",
      "loading": _vm.loading
    },
    on: {
      "open": _vm.onOpen,
      "input": _vm.onInput
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm add-button",
    on: {
      "click": _vm.openForm
    }
  }, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), (_vm.formOpened) ? _c('div', {
    staticClass: "save-panel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.t('Short name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control user-filter-value",
    class: _vm.errorClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.t('Type search name to save')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.t('Save')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-sm btn-link",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v(_vm._s(_vm.t('Cancel')))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a24b0a70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserFilterComponent.vue
// module id = 1341
// module chunks = 2